import { useEffect, useState } from "react";
import { Steps } from "antd";

import PreviewData from "../components/lead-import/PreviewData";
import { useSearchParams } from "react-router-dom";
import { getSummary } from "../actionCreator/importActionCreator";
import { useDispatch } from "react-redux";
import ImportLead from "../components/lead-import/ImportLead";
import BeyondleadzData from "../components/lead-import/BeyondleadzData";
import ConvertLeadSuccess from "../components/lead-import/ConvertLeadSuccess";

const { Step } = Steps;

const LeadImport = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const dispatch = useDispatch();
  const isPreview = status === "preview";
  const isAdvancedFilter = status === "beyondleadzData";
  const isSuccess = status === "success";
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    dispatch(getSummary());
  }, [dispatch]);

  useEffect(() => {
    setCurrent(isPreview ? 1 : isSuccess ? 2 : 0);
  }, [isPreview, isSuccess]);

  return (
    <div className="tw-p-4">
      <h3 className="tw-text-2xl tw-font-semibold tw-text-text-primary">
        {isPreview ? "Review & Select Lead Data" : "Import Leads"}
      </h3>
      <p className="tw-text-sm mb40 tw-text-sub-text tw-font-normal tw-mt-1">
        {isPreview
          ? "Choose which leads to import into your BeyondLeadz CRM"
          : "Connect your data sources to start importing leads into your CRM. Choose from multiple platforms to build your lead database."}
      </p>

      <Steps
        current={current}
        labelPlacement="vertical"
        responsive={false}
        size="small"
        style={{
          maxWidth: 1000,
          margin: "0 auto",
        }}
        className="import-custom-steps"
      >
        <Step
          title={
            <>
              <div className="fw-semibold tw-text-black">Select Sources</div>
              <div className="tw-text-xs tw-text-sub-text">
                Choose lead location
              </div>
            </>
          }
          icon={
            <div
              className={`tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-2 tw-size-[30px] tw-text-sm tw-font-semibold ${[0, 1, 2]?.includes(current) ? "tw-text-white tw-bg-theme" : "tw-text-text-primary tw-border tw-border-solid tw-border-border-secondary"}`}
            >
              1
            </div>
          }
        />
        <Step
          title={
            <>
              <span className="fw-semibold tw-text-black">Review Data</span>
              <div className="tw-text-xs tw-text-sub-text">
                Clean & map fields
              </div>
            </>
          }
          icon={
            <div
              className={`tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-2 tw-size-[30px] tw-text-sm tw-font-semibold ${[1, 2]?.includes(current) ? "tw-text-white tw-bg-theme" : "tw-text-text-primary tw-border tw-border-solid tw-border-border-secondary"}`}
            >
              2
            </div>
          }
        />
        <Step
          title={
            <>
              <span className="fw-semibold tw-text-black">Convert Leads</span>
              <div className="tw-text-xs tw-text-sub-text">Add to pipeline</div>
            </>
          }
          icon={
            <div
              className={`tw-rounded-full tw-flex tw-items-center tw-justify-center tw-p-2 tw-size-[30px] tw-text-sm tw-font-semibold ${[2]?.includes(current) ? "tw-text-white tw-bg-theme" : "tw-text-text-primary tw-border tw-border-solid tw-border-border-secondary"}`}
            >
              3
            </div>
          }
        />
      </Steps>
      {isPreview ? (
        <PreviewData />
      ) : isAdvancedFilter ? (
        <BeyondleadzData />
      ) : isSuccess ? (
        <ConvertLeadSuccess />
      ) : (
        <ImportLead />
      )}
    </div>
  );
};

export default LeadImport;
